import { hasPermissionWithContext } from '@/common/utils/utils';
import { Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IUserContextModel } from '@/store/auth/types';

// TODO: Need to create separate page for this
export function AccessDenied() {
	return (
		<div>Access Denied</div>
	);
}

export default function PermissionRoleRoute() {
	const location = useLocation();
	const authContext: IUserContextModel = useSelector(
		(state: any) => state.userContext
	);
	
	const isPermission = hasPermissionWithContext(location.pathname, authContext);
	return isPermission ? <Outlet /> : <div>Access Denied</div>;
}
